import styled from 'styled-components';
import { detailsBackground, primaryColor } from '../../../../config/colors';
import { Section } from '../../styles';

export const StyledSection = styled(Section)``;

export const ContentWrapper = styled.div`
  background-color: ${detailsBackground};
  padding: 6px 8px;
  overflow: auto;
  height: 150px;
`;

export const ReadMoreParagraph = styled.p`
  font-size: 0.9rem;
  line-height: 24px;
  font-size: 1rem;
  overflow: hidden;
  height: calc(24px * 5 + 6px);
`;

export const LinkLabel = styled.a`
  color: ${primaryColor};
  text-decoration: none;
  display: inline-block;
  padding: 4px 0px;
  font-weight: 600;
  &:active,
  &:active,
  &:visited {
    color: ${primaryColor};
    opacity: 0.8;
  }
`;
